import { useEffect, useState } from "react";
import Pagination from "common/Pagination/Pagination";

interface usePaginationProps<RecordType extends object> {
  data: RecordType[];
  pageSize?: number;
  showSizeChanger?: boolean;
  showLessItems?: boolean;
}

const usePagination = <RecordType extends object>({
  data,
  pageSize: propsPageSize,
  showSizeChanger,
  showLessItems,
}: usePaginationProps<RecordType>): [React.JSX.Element, RecordType[]] => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(propsPageSize ?? 10);

  const onChange = (page: number, pageSize?: number) => {
    setPage(page);
    if (pageSize) {
      setPageSize(pageSize);
    }
  };

  const lastPage = Math.max(1, Math.ceil(data.length / pageSize));
  const currentPage = Math.min(page, lastPage);

  useEffect(() => {
    if (page > lastPage) setPage(lastPage);
  }, [page, lastPage]);

  const pagination = (
    <Pagination
      onChange={onChange}
      pageSize={pageSize}
      current={currentPage}
      total={data.length}
      hideOnSinglePage={true}
      showSizeChanger={showSizeChanger}
      showLessItems={showLessItems}
    />
  );
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedData = data.slice(startIndex, startIndex + pageSize);

  return [pagination, paginatedData];
};

export default usePagination;
